<template>
  <div :class="classes" class="wt-upload-file">
      <el-upload
      :style="{height:height?height+'px':'',width:width?width+'px':''}"
      :action="action"
      ref="upload"
      :headers="headers"
      :disabled="disabled"
      :with-credentials="true"
      :listType="listType"
      :limit="limit"
      :file-list="fileList"
      :before-upload="beforeAvatarUpload"
      :show-file-list="showFileList"
      :multiple="multiple"
      :drag="drag"
      :accept="accept"
      :data="data"
      :on-success="onSuccess"
      :on-remove="onRemove"
      :on-error="onError"
      :auto-upload="autoUpload"
      :class="{'wt-upload-file--no-add':(!multiple&&fileList.length!=0||!isAdd)}">
          <slot/>
      </el-upload>
  </div>
</template>

<script>
// 组件class前缀
import { Upload } from 'element-ui'
import axios from 'axios'
const prefixCls = 'wt-upload-file'
export default {
  name: 'wt-upload-file-base',
  props: {
    value: {
      type: [Array, Object, String],
      default: function () {
        return []
      }
    },
    action: {
      type: String,
      default: '/apartments/api/apartments/upload-image'
    },
    headers: {
      type: Object,
      default: function () {
        return {}
      }
    },
    multiple: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    name: {
      type: String,
      default: 'file'
    },
    listType: {
      type: String,
      default: 'picture-card'
    },
    limit: {
      type: Number,
      default: 9
    },
    beforeAvatarUpload: {
      type: Function,
      default: function () {
        return () => {}
      }
    },
    showFileList: {
      type: Boolean,
      default: true
    },
    drag: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: ''
    },
    imgUrl: {
      type: String,
      default: ''
    },
    // 只上传一张图片时，手否显示上传图片（用于按钮上传，不显示上传图片）
    showFile: {
      type: Boolean,
      default: true
    },
    pictureStyle: {
      // oss图片样式
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    pathUrlName: {
      type: String,
      default: ''
    },
    height: {
      type: [Number, String],
      default: 0
    },
    width: {
      type: [Number, String],
      default: 0
    },
    isUploadExcel: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'el-upload': Upload
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    isShowName () {
      return this.listType === 'text'
    }
  },
  data () {
    return {
      isAdd: true,
      fileList: [], // 以上传的文件列表
      upload: this.$refs.upload,
      currentValue: this.value
    }
  },
  watch: {
    value: {
      handler: function (val, old) {
        if (val !== old) {
          this.currentValue = val
        }
        // 第一次初始化
        this.fileList = this.build_file_list(this.value)
      },
      immediate: true
    },
    currentValue: {
      handler (val, old) {
        if (this.limit && val && val.length >= this.limit) {
          this.isAdd = false
        }
        if (val && val.length < this.limit) {
          this.isAdd = true
        }
        if (val !== old) {
          this.$emit('input', this.currentValue)
        }
        this.fileList = this.build_file_list(val)
      },
      deep: true
    }
  },
  methods: {
    submit () {
      this.upload.submit()
    },
    abort () {
      this.upload.abort()
    },
    onSuccess (res, file) {
      if (this.listType === 'text') {
        this.$emit('input', res)
      } else {
        if (!this.multiple) {
          this.fileList = []
          this.fileList.push(this.build_file_item(this.isShowName ? file : file.response))
          this.currentValue = this.isShowName ? file : file.response
        } else {
          this.fileList.push(this.build_file_item(this.isShowName ? file : file.response))
          this.currentValue.push(this.isShowName ? file : file.response)
        }
        this.$emit('input', this.currentValue)
      }
    },
    // 导入数据时，如果出错，错误时间处理
    onError (err, file, fileList) {
      let message = err.message
      let errMessage = typeof (err) === 'object' ? JSON.parse(message) : message

      console.log('err+++', errMessage)
      this.$emit('onError', errMessage, file, fileList)
    },
    onRemove (file, fileList) {
      if (!this.multiple) {
        this.currentValue = null
        this.isAdd = true
      } else {
        for (let i = 0; i < this.currentValue.length; i++) {
          if (this.pathUrlName ? this.currentValue[i][this.pathUrlName] === file.path : this.currentValue[i] === file.path) {
            this.currentValue.splice(i, 1)
            break
          }
        }
      }
      this.$emit('input', this.currentValue)
    },
    // 根据相对路径，获得图片的完整路径
    get_image_url (filePath) {
      return (
        this.imgUrl +
                filePath +
                (this.pictureStyle ? this.pictureStyle : '')
      )
    },
    build_file_item (filePath) {
      if (this.isShowName) {
        return {
          url: this.get_image_url(filePath.url),
          path: filePath,
          name: filePath.name
        }
      } else {
        return {
          url: this.get_image_url(filePath),
          path: filePath
        }
      }
    },
    build_file_list (value) {
      console.log('build_file_list', value)
      let list = []
      if (this.listType === 'text') {
        return list
      } else {
        if (value) {
          if ((this.isShowName && !this.multiple) || typeof value === 'string') {
            list.push(this.build_file_item(value))
          } else {
            value.forEach((item, index) => {
              list.push(this.build_file_item(this.pathUrlName ? item && item[this.pathUrlName] : item))
            })
          }
        }
        return list
      }
    },
    handleChange (file, fileList) {
      this.is_change = true
      console.log('file+++++', file)
      if (!this.multiple) {
        this.upload.clearFiles()
        this.$nextTick(_ => {
          // 下一帧执行，以便能触发动画
          this.upload && (this.upload.uploadFiles = [file])
        })
      }
    }
  },
  created () {
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.wt-upload-file--no-add{
   .el-upload {
        display: none!important;
    }
}
    .wt-upload-file{
        &--no-add{
        .el-upload--picture-card {
            width: 100%;
            height: 100%;
            border: none;
            img {
                border-radius: 5px;
            }
    }
        }
    }
.bill{
    // ****
    // &__avatar{
    //     &--kkkk{

    //     }
    // }
    // &--active{

    // }
}
</style>
